import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import "../../../node_modules/@chenfengyuan/datepicker/dist/datepicker.esm";
import GigyaManager from "../business/GigyaManager";
import Constants from "../business/Constants";
import moment from "moment";
import PromoApi from "mbpromo/src/api/PromoApi";
import Pristine from "pristinejs";

class FormCtrl extends SmartComponent {
	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);

		this.userPrivacyProfiling = false;
		this.files = [];
		this.promoApi = new PromoApi({promoCode: Constants.API_PROMOCODE});

		this.productNumber = this.element.dataset["productNumber"] || 1;
		this.alwaysOn = true;

		this.openDayTime = '';
		this.closeDayTime = '';
		this.openHour = '';
		this.closeHour = '';

		this.init();
	}

	init() {
		this.loadChildComponents(this);
		this.startLoader();

		GigyaManager.getLoggedUserCached().then((u) => {
			var ch = u.data[Constants.CH_PROMO];
			if(typeof ch !== "undefined" && ch != null && ch != ""){
				$('#regulationAcceptance').remove();
			}

			this.userPrivacyProfiling = u.preferences.privacy_profiling.isConsentGranted;

			// termine ultimo per richiedere il premio
			this.promoApi.status().then((resp) => {
				let response = resp.body.response.data;

				let gamePlayOpened = response.gameplay.opened;
				this.openHour = parseInt(response.gameplay.hours.start.raw);
				this.closeHour = parseInt(response.gameplay.hours.end.raw);
				this.openDayTime = response.promo.dates.receipt_start_date.raw;
				this.closeDayTime = response.promo.dates.receipt_end_date.raw;

				if(gamePlayOpened === "false"){
					let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__content">
                                                            <p>${response.promo.ended_description}</p>
                                                            <a href="/promozioni/promocolazione2022/area-personale" class="button">Torna all’area personale</a>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
					$(this.element).append(tmplModalGeneric);
					this.loadChildComponents(this);
					$('.main-form').remove();
					this.removeLoader();
				} else if(moment(response.promo.dates.receipt_end_date.raw).diff(moment()) < 0){
					let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">${response.promo.prize_request_ended_description}</h2>
                                                            <a href="/promozioni/promocolazione2022/area-personale" class="button">Torna all’area personale</a>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
					$(this.element).append(tmplModalGeneric);
					this.loadChildComponents(this);
					$('.main-form').remove();
					this.removeLoader();
				} else {
					this.alwaysOn = (this.openHour === 0 && this.closeHour === 24);
					if(!this.alwaysOn){
						let currentHours = new Date().getHours();
						let isOpened = currentHours >= this.openHour && currentHours < this.closeHour;
						let title = moment(response.promo.dates.receipt_end_date.raw).diff(moment(), 'days') >= 1 ? 'Torna domani!' : '';
						if(!isOpened){
							let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">${title}</h2>
                                                            <p>Il concorso è attivo dalle ore 00.01 del 27.01.2022 alle ore 18.00 del 04.05.2022</p>
                                                            <a href="/promozioni/promocolazione2022/area-personale" class="button">Torna all’area personale</a>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
							$(this.element).append(tmplModalGeneric);
							this.loadChildComponents(this);
							$('.main-form').remove();
							this.removeLoader();
						}
					}
					if(this.productNumber === 1){
						$('#product2').parents(".pp-dropdown-cnt").hide();
						$('#product2').remove();
					}

					this.promoApi.elencoStore(false).then((result)=>{
						this.buildDropdownStore(result.body);
						this.promoApi.elencoProdotti().then((result)=>{
							this.productData = result.body;
							this.buildDropdownProduct(this.productData);
							this.buildDropdownRegioni();
							this.buildDropdownProvince();

							let form = document.getElementById("template-form");

							let formConfig = {
								// class of the parent element where the error/success class is added
								classTo: 'col-form',
								errorClass: 'error',
								successClass: 'has-success',
								// class of the parent element where error text element is appended
								errorTextParent: 'col-form',
								// type of element to create for the error text
								errorTextTag: 'span',
								// class of the error text element
								errorTextClass: 'error-field'
							};

							this.trimRequired();

							// init form validator
							this.pristine = new Pristine(form, formConfig);
							// add validator for some fields
							this.validatorProduct('product');
							this.validatorProduct('product2');
							this.validatorData();
							this.validatorReceiptPhoto();

							// force validate
							datePicker.on('pick.datepicker', (e) => {
								setTimeout(() => {
									e.currentTarget.removeAttribute('readonly');
									this.pristine.validate(document.getElementById('dataCal'));
									e.currentTarget.setAttribute('readonly',true);
								}, 100)
							});

							this.removeLoader();
						})
					})

					$('#regione').change(()=>{
						this.startLoader();
						this.buildDropdownProvince($('#regione').val());
						this.removeLoader();
					});
				}
			});
		}, () => {
			window.location.href = "/login?urlBack="+window.location.href.replace(window.location.origin, "")+"&regSource="+Constants.PROMO_CODE;
		})

		$.fn.datepicker.languages['it-IT'] = {
			format: 'dd/mm/yyyy',
			days: ['Domenica','Lunedì','Martedì','Mercoledì','Giovedì','Venerdì','Sabato'],
			daysShort: ['Dom','Lun','Mar','Mer','Gio','Ven','Sab'],
			daysMin: ['Do','Lu','Ma','Me','Gi','Ve','Sa'],
			weekStart: 1,
			months: ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'],
			monthsShort: ['Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'],
			autoHide: true
		};
		const datePicker = $('[data-toggle="datepicker"]').datepicker(
			{
				language: 'it-IT',
				format: 'dd-mm-yyyy',
				startDate: new Date(2022,0,25),
				endDate: new Date()
			}
		);



		$('input[name="storeType"]').change(()=>{
			let val = $('input[name="storeType"]:checked').val();
			this.startLoader();
			this.promoApi.elencoStore(val != 'offline').then((result)=> {
				this.buildDropdownStore(result.body);
				this.removeLoader();
			});
		})

		//IMAGE VIEW
		$('#foto-scontrino').change(() => {
			var input =  $('#foto-scontrino')[0];
			let file = input.files[0];
			var maxSize = $(input).data('max-size');


			if (maxSize > file.size) {
				this.startLoader();

				this.promoApi.uploadFile(file, this.files.length == 0 ? 1 : 2).then((resp)=>{
					let data = resp.body;
					let filename_server = data.response.data.filename;
					let idx_file = filename_server.split(".")[0];
					var reader = new FileReader();
					reader.onload = function (e) {
						if (filename_server.match(/pdf$/)) {
							$('.file-list').append('<div class="row" id="'+idx_file+'"><div class="figure"><img' +
                                ' src="/fe-web/img/icons/avatar_placeholder.jpg"></div><div' +
                                ' class="file-name">' + file.name + '</div><div class="delete-file" component-click="removeFile(\''+idx_file+'\')"></div></div>');
						} else {
							$('.file-list').append('<div class="row" id="'+idx_file+'"><div class="figure"><img src="' + e.target.result + '"></div><div class="file-name">' + file.name + '</div><div class="delete-file" component-click="removeFile(\''+idx_file+'\')"></div></div>');
						}
					}
					reader.readAsDataURL(file);
					this.files.push(filename_server);
					if(this.files.length == 2){
						$('#foto-scontrino').prop("disabled", true);
						$('.carica-scontrino').addClass('disabled');
					}else{
						$('#foto-scontrino').prop("disabled", false);
						$('.carica-scontrino').removeClass('disabled');
					}
					$('#foto-scontrino').val('');

					// before delete all error messages
					$(".uploadFile .pristine-error").empty();

					// and then force validate receipt photo
					this.pristine.validate(document.getElementById('foto-scontrino'));

					this.removeLoader();
				}, () => {
					//TODO POPUP ERRORE
					$('#foto-scontrino').prop("disabled", false);
					$('.carica-scontrino').removeClass('disabled');
					$('#foto-scontrino').val('');
					this.removeLoader();
				})
			}else{
				$('#foto-scontrino').addClass('error');
				if($(".uploadFile .error-field").length){
					$(".uploadFile .error-field").append("<br>Il file caricato è troppo grande");
				}else {
					$(".uploadFile").append('<span class="pristine-error error-field">Il file caricato è troppo grande</span>');
				}
			}
		});

		$('#conferma').on('click', (e) => {
			e.preventDefault();
			this.submitForm();
		});
	}

	buildDropdownStore(stores){
		let options = '<option value="-" default="true">Scegli lo store</option>';

		let storeList = stores.response.data;
		for(var i = 0; i < storeList.length; i++){
			options += `<option value="${storeList[i].tag}">${storeList[i].description}</option>`
		}
		$('#market').html(options);

		if(storeList.length == 1){
			$('#market').val(storeList[0].tag);
			$('#market').hide();
			$('#market').next().hide();
		}else{
			$('#market').val("-");
		}
	}

	buildDropdownProduct(productData){
		let options = '';

		let productList = productData.response.data;
		for(var i = 0; i < productList.length; i++){
			options += `<option value="${productList[i].code}">${productList[i].description}</option>`
		}


		$('#product').html('<option value default="true"">Scegli il prodotto Numero1</option>'+options);
		$('#product2').html('<option value default="true">Scegli il prodotto Numero2</option>'+options);
		$('#product').val("");
		$('#product2').val("");
	}

	async buildDropdownProvince(idRegion){
		let options = '<option value="" default="true">Scegli la provincia</option>';

		if(idRegion){
			let resp = await this.promoApi.elencoProvince(idRegion);
			let provinceList = resp.body.response.data;
			for(var i = 0; i < provinceList.length; i++){
				options += `<option value="${provinceList[i].id}" data-region-id="${provinceList[i].id}">${provinceList[i].description}</option>`
			}

			this.removeLoader();
		}



		$('#provincia').html(options);
		$('#provincia').val("");
	}

	async buildDropdownRegioni(){
		let options = '<option value="" default="true">Scegli la regione</option>';

		let resp = await this.promoApi.elencoRegioni("");
		let regionList = resp.body.response.data;
		for(var i = 0; i < regionList.length; i++){
			options += `<option value="${regionList[i].id}" data-region-id="${regionList[i].id}">${regionList[i].description}</option>`
		}

		$('#regione').html(options);
		$('#regione').val("");
	}

	submitForm(){
		this.startLoader();
		this.validateForm();
	}

	removeFile(idx){
		$('#'+idx).remove();
		for(let i = 0; i < this.files.length; i++ ){
			if(this.files[i].indexOf(idx) != -1){
				this.files.splice(i, 1);
			}
		}
		if(this.files.length == 2){
			$('#foto-scontrino').prop("disabled", true);
			$('.carica-scontrino').addClass('disabled');
		}else{
			$('#foto-scontrino').prop("disabled", false);
			$('.carica-scontrino').removeClass('disabled');
		}
	}

	// CHECK VALIDAZIONE
	validateForm(){
		$('.error-feedback').remove();
		$('input, select').removeClass('error');

		let valid = this.pristine.validate();
		if(valid){
			let date = $('#dataCal').val();
			let arrDate = date.split('-');
			let day = arrDate[0];
			let month = arrDate[1];
			let year = arrDate[2];
			let hours = $('#hours').val();
			let minutes = $('#minutes').val();
			let isoDate = year + '-' + month + '-' + day;
			let isoDateTime = isoDate + ' ' + hours + ':' + minutes;
			if(moment(isoDateTime).diff(moment()) > 0){
				$('#dataCal').addClass('error');
				$('.row-form--date').append('<span class="error-feedback"><span class="icon-error">!</span> Attenzione! L’iniziativa è valida per gli acquisti effettuati dalle ore 00.01 del 27.01.2022 alle ore 18.00 del 04.05.2022.</span>');
				this.removeLoader();
				this.scrollToError();
				return false;
			}
		}

		if(valid) {
			this.sendForm();
		} else {
			this.scrollToError();
			this.removeLoader();
			return false;
		}
	}

	removeLoader(){
		$('.tool_loader').fadeOut(500).remove();
		$('body').removeClass('noScroll');
		$('#conferma').prop("disabled", false).removeClass('disabled');
	}

	startLoader(){
		$('.mb-promo').append('<div data-tool-loader="" class="tool_loader"><svg><use xlink:href="#svg_loader"></use></svg></div>');
		$('body').addClass('noScroll');
		$('#conferma').prop("disabled", true).addClass('disabled');
	}

	//VALIDAZIONE SINGOLI CAMPI
	sendForm(){
		let market = $('#market').val();
		let product = $('#product').val();
		let product2 = $('#product2').val();
		let date = $('#dataCal').val();
		let arrDate = date.split('-');
		let day = arrDate[0];
		let month = arrDate[1];
		let year = arrDate[2];
		let hours = $('#hours').val();
		let minutes = $('#minutes').val();
		let numScontrino = $('#numScontrino').val();
		let euro = $('#euro').val();
		let cent = $('#cent').val();

		let regionId = $('#regione').val();
		let provinceId = $('#provincia').val();

		let basedata = {
			receipt_product_code: product,
			receipt_day: day,
			receipt_month: month,
			receipt_year: year,
			receipt_minutes: minutes,
			receipt_hour: hours,
			receipt_number: numScontrino,
			receipt_amount_euros: euro,
			receipt_amount_cents: cent,
			receipt_file_front: this.files[0]
		}

		let customdata = {
			store: market,
			products: [{code: product, quantity:1}],
			user_profiling: this.userPrivacyProfiling ? 1 : 0,
			// prizeid: prizeId,
			regionid: regionId,
			provinceid:  provinceId
		}

		if(this.productNumber > 1){
			customdata.products.push({code: product2, quantity:1})
		}


		if(this.files.length > 1){
			basedata['receipt_file_back'] = this.files[1];
		}


		if($('#acceptance').length == 0){
			this.doPlayReceiptCall({basedata, customdata});
		}else{
			GigyaManager.addCH(Constants.CH_PROMO).then(() => {
				this.doPlayReceiptCall({basedata, customdata}, true);
			}, (err)=>{
				console.log(err);
				let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                            <p>Ti preghiamo di riprovare più tardi!</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
				$(this.element).append(tmplModalGeneric);
				this.loadChildComponents(this);
				this.removeLoader();
			})
		}
	}

	doPlayReceiptCall(scontrino, flaggedCH){
		this.promoApi.giocaScontrino(scontrino).then((resp)=>{
			let data = resp.body;
			if(data.response.data.play.status == "WIN"){
				window.location.href='/promozioni/promocolazione2022/hai-vinto?pt='+data.response.data.play.token+"&pm=1";
			}else{
				window.location.href='/promozioni/promocolazione2022/non-hai-vinto';
			}
		},(resp) =>{
			this.removeLoader();
			if(flaggedCH){
				GigyaManager.removeCH(Constants.CH_PROMO);
			}
			let data = resp.body;
			let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto!</h2>
                                                            <p>${data.status.errors.data.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
			$(this.element).append(tmplModalGeneric);
			this.loadChildComponents(this);
		})
	}

	/**
	 * Trim all required fields
	 */
	trimRequired(){
		Pristine.addValidator('required', (value) => {
			return ( value.trim() !== '' );
		}, "", 5, false);
	}

	/**
	 * Check value product
	 * @param {String} idField
	 * @return {Boolean}
	 */
	validatorProduct(idField){
		let id = document.getElementById(idField);
		this.pristine.addValidator(id, (value) => {
			let productArr = this.productData.response.data.map((o) => o.code);
			if (productArr.indexOf(value) >= 0){
				return true;
			}
			return false;
		}, "", 5, false);
	}

	/**
	 * Check between data
	 * @return {Boolean}
	 */
	validatorData(){
		let id = document.getElementById('dataCal');
		this.pristine.addValidator(id, (value) => {
			let arrDate = value.split('-');
			let day = arrDate[0];
			let month = arrDate[1];
			let year = arrDate[2];

			let startDate = '20220127';
			let endDate = '20220504';
			let selectedDate = year + month + day;
			if ( selectedDate >= startDate && selectedDate <= endDate ){
				return true
			}
			return false;
		}, "Attenzione! L’iniziativa è valida per gli acquisti  effettuati dalle 00:01 del 27-01-2022 alle 18:00 del 04-05-2022", 2, false);
	}

	/**
	 * Check media inserted
	 * @return {Boolean}
	 */
	validatorReceiptPhoto(){
		let id = document.getElementById('foto-scontrino');
		this.pristine.addValidator(id, () => {
			if(this.files.length > 0) {
				return true;
			}
			return false;
		}, "Devi caricare almeno una foto dello scontrino!", 2, false);
	}

	/**
	 * Scroll to error
	 */
	scrollToError(){
		$([document.documentElement, document.body]).animate({
			scrollTop: $(".error").offset().top - 25
		}, 1500);
	}
}
export default FormCtrl;
